import type { ServiceConfiguration } from '../feature-service-types';

import type { I18nTranslations } from '../types';
import { debug } from './debugging';

interface I18nResponse {
  translations?: I18nTranslations;
}

export async function fetchI18nMessages(
  apiConfig: ServiceConfiguration,
  language: string,
): Promise<I18nTranslations> {
  const tenant = (apiConfig.customConfig?.tenant || '') as string;
  const application = 'socialmediaforwardingnotice';
  const fetchUrl = `${apiConfig.origin}${apiConfig.path}?tenant=${encodeURIComponent(tenant)}&language=${encodeURIComponent(language)}&application=${encodeURIComponent(application)}`;

  debug('i18n', fetchUrl);

  let responseObject: I18nResponse = {};

  try {
    const response = await fetch(fetchUrl);

    responseObject = (await response.json()) as I18nResponse;
  } catch (error) {
    if (error instanceof Error) {
      debug(`fetchI18nMessages(): ${error.message} (${decodeURIComponent(fetchUrl)})`);
    }
  }

  if (
    !responseObject.translations ||
    Object.keys(responseObject.translations).length === 0 ||
    !responseObject.translations.noticeText
  ) {
    debug(`fetchI18nMessages(): no i18n values found! (${decodeURIComponent(fetchUrl)})`);
    responseObject.translations = {
      noticeText: `[[missing ${language} i18n translations]]`,
      otherSitesLinkCaption: '',
    };
  }

  return responseObject.translations;
}
